import type { RouteRecordRaw } from 'vue-router'

import { ROUTES as AUTH_ROUTES } from '~/scopes/auth/routes'
import { ROUTES as ROUTES_NAMES } from '~/scopes/recycling/routes-names'

export const ROUTES = {
  OFFER: 'recycling_funnel_device_offer',
  CATEGORY: 'recycling_funnel_category',
}

const routes: RouteRecordRaw[] = [
  {
    path: '/:locale/recycling-funnel/category',
    component: () => import('./RecyclingCategory.vue'),
    name: ROUTES_NAMES.CATEGORY,
    meta: {
      disableClientSideNavigation: () => true,
    },
  },
  {
    path: '/:locale/recycling-funnel/device/:deviceCategory/offer',
    component: () => import('./RecyclingOffer.vue'),
    name: ROUTES_NAMES.OFFER,
    meta: {
      disableClientSideNavigation: () => true,
      auth: {
        required: true,
        redirection: {
          name: AUTH_ROUTES.AUTH.LOGIN,
          query: { bm_journey: 'recycling' },
        },
      },
    },
  },
]

export default routes
